import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";

export default function Refunds() {
const {user,dispatch} = useAuthContext()
    const [isLoading,setIsLoading] = useState(true)
const [refunds,setRefunds] = useState([])


const navi = useNavigate()


const fetchData = async () => {
    setIsLoading(true);
    try {
      const refundResponse = await axios.get(
        `${ApiConnectionString}/api/MyRefunds`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (refundResponse.status === 200) {
        setRefunds(refundResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching refund data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

  },[user])

  if(isLoading){
    return(
      <LoadingSpinner /> 
    )
  }else{
    return (
      <div> 
            <div className='lightBlueBanner mt-2 text-center'>
              <p className='fw-bold mx-3 p-1'>Refunds</p>
            </div>
        
         
      {refunds.length > 0 ? (
        <div>
          <table className="custom-table">
                        <thead className="blueBanner">
                          <tr>
                            <th>Club</th>
                            <th>Package</th>
                            <th>Ammount</th>
                   
                          </tr>
                        </thead>
                        <tbody>
            {refunds.map((pay) => (
              <tr key={pay.id}>
                <td>{pay.clubName}</td>
                <td>{pay.name}</td>
                <td>£{pay.amount / 100}</td>     
              </tr>
            ))}
          </tbody>
        </table>
  
        </div>
      ) : (
        <p>No refunds have been made</p>
      )}
      
      </div>
    )
  }
  

}